<template>
  <div class="layout-column-menu">
    <ul class="column-options">
      <li @click='select(obj)' v-for='obj, i in columnTypes'><a href='#'><img :src='columnImage(i+1 +".svg")'/></a></li>
    </ul>
  </div>
</template>
<script>
const columnImagesContext = require.context('./images', false, /\.svg$/)
export default {
  props: {

  },
  data () {
    return {
      columnTypes: [
        {class: 'equal', columns: 1},
        {class: 'equal', columns: 2},
        {class: 'equal', columns: 3},
        {class: '2thirds', columns: 2},
        {class: '2thirds layout-reverse', columns: 2},
        {class: 'equal', columns: 4},
        {class: '3quarters', columns: 2},
        {class: '3quarters layout-reverse', columns: 2},
      ],
    }
  },
  created () {
  },
  methods: {
    columnImage (path) {
      return columnImagesContext('./' + path)
    },
    select (columnDefinition) {
      this.$emit('select', columnDefinition)
    }
  }
}
</script>
<style lang='scss' scoped>
  .layout-column-menu {
    
  }
  .column-options {
    display: flex;
    flex-wrap: wrap;
    li {
      background-color: white;
      flex: 0 0 32%;
      margin-bottom: 15px;
      a {
        display: block;
        height: 100%;
        img {
          display:block;
        }
      }
      & + li {
        margin-left: 1%;
      }
      &:nth-child(3n+1) {
        margin-left: 0;
      }
      &:hover {
        background-color: #bbb;
      }
    }
  }
</style>